/**
 * 現在のユーザーが Cognito 'admin' グループに属するかを判定するフック
 *
 * IDトークンのクレームからUI表示用に判定する。
 * サーバー側（/api/admin/*）でも必ず再検証されるため、これはUIゲートに過ぎない。
 */

import { useQuery } from '@tanstack/react-query';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useAuth } from '@/hooks/useAuth';
import { ADMIN_COGNITO_GROUP } from '@/constants/adminDashboard';

export function useIsAdmin(): { isAdmin: boolean; isChecking: boolean } {
  const { isAuthenticated, isLoading, user } = useAuth();

  const { data, isLoading: isQueryLoading } = useQuery({
    // ユーザーIDをキーに含める: 管理者ログアウト直後に別ユーザーが
    // ログインした場合にキャッシュされた判定が漏れないようにする
    queryKey: ['isAdmin', user?.id ?? 'anonymous'],
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 10,
    queryFn: async () => {
      const session = await fetchAuthSession({ forceRefresh: false });
      const groups = session.tokens?.idToken?.payload['cognito:groups'];
      return Array.isArray(groups) && groups.includes(ADMIN_COGNITO_GROUP);
    },
  });

  return {
    isAdmin: data === true,
    isChecking: isLoading || (isAuthenticated && isQueryLoading),
  };
}
